import { NgModule, Pipe, PipeTransform } from '@angular/core';

export function pad(number: number): string {
  return number < 10 ? `0${number}` : number.toString();
}

export function convertSpDate(date: string): Date {
  return date ? new Date(parseInt(date.replace(/\/Date\(|\)\//g, ''), 10)) : null;
}

const today = new Date();
@Pipe({
  name: 'flightDate'
})
export class FlightDatePipe implements PipeTransform {

  transform(value: string): string {
    const date = convertSpDate(value);

    if (!date) {
      return '--:--';
    }

    if (today.toDateString() === date.toDateString()) {
      return `${date.getUTCHours()}:${pad(date.getMinutes())}`;
    } else {
      return `${date.getUTCHours()}:${pad(date.getMinutes())}/${date.getUTCDate()}`;
    }
  }

}

@NgModule({
  imports: [],
  declarations: [FlightDatePipe],
  exports: [FlightDatePipe]
})
export class FlightDatePipeModule { }